<template>
    <div class="row mb-5 mt-5">
      <div class="col">
        <div class="row">
          <div class="col-lg-5 mb-3">
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label pt-0">Status</label>
              <div class="col-sm-9">
                <div class="d-flex flex-wrap gap-3 align-items-center">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="filter_status" id="status_all" value="all" v-model="filters.status">
                    <label class="form-check-label" for="status_all">Vsi</label>
                  </div>
                  <template v-for="[typeKey, typeLabel] in offerStatuses" :key="typeKey">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="filter_status" :id="'status_' + typeKey" :value="typeKey" v-model="filters.status">
                      <label class="form-check-label" :for="'status_' + typeKey">{{ typeLabel }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label">Ponudba</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model.lazy="filters.offerNumber" placeholder="Vnesite del številke ..." />
              </div>
            </div>
          </div>
          <div class="col-lg-7 mb-3 border-start-lg">
            <SelectCustomerEntity
              col-class-left="col-sm-3"
              col-class-right="col-sm-9"
              :customerID="filters.customer"
              :facilityID="filters.facility"
              :canChange="true"
              @change="updateCustomerEntity"
            />
          </div>
        </div>
        <div class="row">
          <div class="col text-end">
            <button class="btn btn-secondary btn-sm" @click="resetFilters">
              <i class="bi bi-x-circle me-1"></i>Pobriši filtre
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-stripped table-sm table-hover">
            <thead>
              <tr>
                <th scope="col" class="bg-light">Stranka</th>
                <th scope="col" class="bg-light">Objekt</th>
                <th scope="col">Št. ponudbe</th>
                <th scope="col">Ustvarjena</th>
                <th scope="col">Poslana</th>
                <th scope="col">Status</th>
                <th scope="col">Zadnja</th>
                <th scope="col">Skupaj</th>
              </tr>
            </thead>
            <tbody>
              <tr role="button" v-for="offer in offers" :key="offer.id">
                <td  @click="selectOffer(offer, true)" class="bg-light">{{ offer.customerName }}</td>
                <td  @click="selectOffer(offer, true)" class="bg-light">{{ offer.facilityName }}</td>
                <td  @click="selectOffer(offer)">{{ offer.numberDisplay }}</td>
                <td  @click="selectOffer(offer)">{{ $dayjs(offer.dateCreated).format($DATE_FORMAT_DISPLAY) }}</td>
                <td  @click="selectOffer(offer)">{{ offer.dateOfferSent ? $dayjs(offer.dateOfferSent).format($DATE_FORMAT_DISPLAY) : '' }}</td>
                <td  @click="selectOffer(offer)">{{ offer.status }}</td>
                <td  @click="selectOffer(offer)">{{ offer.isLatest }}</td>
                <td  @click="selectOffer(offer)">{{ offer.total ? offer.total.toFixed(2) : '0.00' }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Paging v-if="offers?.length" :paging="paging" @change="setPageNum" />
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { listEntitiesAsync } from "../api" // Ensure correct path for api
import { useOffers } from "../composition-api/useOffers" // Adjust path if needed
import { EMPTY_GUID } from "../utils/constants"
import { useEnums } from "../composition-api/useEnums"

defineOptions({ name: "Offers" })

const { paging, filters, setPageNum, resetPaging, offers } = useOffers()
const { offerStatuses, loadEnumsAsync } = useEnums()
const router = VueRouter.useRouter()

const selectOffer = (offer, openInNewWindow = false) => {
  console.log(offer)
  const routeData = router.resolve({ name: "OfferEdit", params: { offerId: offer.id } })
  if (openInNewWindow) {
    window.open(routeData.href, "_blank")
  } else {
    router.push(routeData)
  }
}

const updateCustomerEntity = (e) => {
  filters.customer = e.customerID
  filters.facility = e.facilityID
}

const resetFilters = () => {
  filters.status = "all"
  filters.customer = ""
  filters.facility = ""
  filters.offerNumber = ""
}

onMounted(() => {
  loadEnumsAsync()
})
</script>
